import React, { Component } from 'react'
import { Row } from 'react-bootstrap'
import axios from 'axios'
import DataSource from './DataSource'
import swal from 'sweetalert'
import { handleErrorFetchingData } from '../../../../functions/errorHandling'


class DataSourceListItem extends Component {
  state = {
    displayName: this.props.dataSource.name || "",
    displayClientName: this.props.dataSource.client_name || "",
    isExpanded: false,
    dataSourceObject: null,
    fetchingRequestObject: false,
    errorMessage: "",
    submittingRequest: false
  }

  handleDeleteDataSource = () => {
    const { dataSource, getDataSources } = this.props
    this.setState({ submittingRequest: true }, () => {
      swal({
        text: `Deleting data source... Please stand by.`,
        icon: require("../../../../static/images/spinner.gif"),
        button: false
      })
      axios.delete(dataSource.url, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        getDataSources(1)
        this.setState({ isExpanded: false, dataSourceObject: null })
        swal({
          title: "Success",
          text: `Data source ${dataSource.name} has been deleted`,
          icon: "success",
          button: "Continue",
        })
      }).catch(error => {
        handleErrorFetchingData(error, "There was an error in deleting the data source")
        console.log(error, error.response)
      }).finally(() => {
        this.setState({ submittingRequest: false })
      })
    })
  }

  handleGetDataSourceObject = () => {
    const { dataSource } = this.props

    this.setState({ fetchingRequestObject: true }, () => {
      axios.get(dataSource.url, {
        "headers": { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        this.setState({ dataSourceObject: response.data })
      }).catch(error => {
        console.log(error, error.response)
        handleErrorFetchingData(error, "There was an error in getting the data source")
        this.setState({ dataSourceObject: null, errorMessage: "Could not retrieve the data source" })
      }).finally(() => {
        this.setState({ fetchingRequestObject: false })
      })
    })
  }

  handleExpand = () => {
    const { isExpanded } = this.state
    this.setState({ isExpanded: !isExpanded }, () => {
      if (!isExpanded) this.handleGetDataSourceObject()
    })
  }

  handleChangeDisplayValue = (field, value) => this.setState({ [field]: value })

  render() {
    const { getDataSources } = this.props
    const { isExpanded, fetchingRequestObject, dataSourceObject, displayName, displayClientName } = this.state

    return (
      <React.Fragment>
        <tr
          onClick={ this.handleExpand }
          className={`data-access-request-table-item ${ isExpanded && "active" }`}
        >
          <td>
            { displayName }
          </td>
          <td>
            { displayClientName }
          </td>
        </tr>
        { Boolean(isExpanded) &&
          <tr className="data-access-request-table-item-expanded">
            <td colSpan={4}>
              <Row style={{ margin: "0px" }}>
                { fetchingRequestObject ?
                  <center>
                    <div id="not-found">
                      <img alt="loader" width={100} src={require("../../../../static/images/spinner.gif")}/>
                    </div>
                  </center>
                  :
                  <div>
                    { dataSourceObject ?
                      <DataSource
                        dataSource={ dataSourceObject }
                        getDataSources={ getDataSources }
                        handleDeleteDataSource={ this.handleDeleteDataSource }
                        handleGetDataSourceObject={ this.handleGetDataSourceObject }
                        handleChangeDisplayValue={ this.handleChangeDisplayValue }
                      />
                      :
                      "Could not get the data source object"
                    }
                  </div>
                }
              </Row>
            </td>
          </tr>
        }
      </React.Fragment>
    )
  }
}

export default DataSourceListItem


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/DataSourceListItem.js